import { render, staticRenderFns } from "./excel-template.vue?vue&type=template&id=5f814f5c&scoped=true"
import script from "./excel-template.vue?vue&type=script&lang=ts"
export * from "./excel-template.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f814f5c",
  null
  
)

export default component.exports